import classes from "./MainContainer.module.css";
import React, { useContext, useEffect } from "react";
import { Route, Link, Routes, useLocation } from "react-router-dom";
import Routers from "../components/routes/Routes";
import Header from "./common/Header";
import Footer from "./common/Footer";

const MainContainer = ({ title, handleToggleSidebar }) => {
  const { PROTECTED_ROUTES } = Routers();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/sms-api-document") {
      window.open(
        // "https://sms-apidoc.appantech.com/view/8389965/2sAXxS8rrs#d8e2d32b-7095-4c0b-ae9e-a67da6a48e84",
        // "_blank"
        // `https://documenter.getpostman.com/view/38332326/2sB3dMwWLf`
        // "https://documenter.getpostman.com/view/38332326/2sBXc7KPaM"
        "https://documenter.getpostman.com/view/38332326/2sBXc8nhk2"
      );
    }else if (location.pathname === "/rcs-api-document") {
      window.open(
        `https://documenter.getpostman.com/view/38332326/2sBXc8nhk1`
      );
    }
  }, [location.pathname === "/sms-api-document", location.pathname === "/rcs-api-document"]);

  let processedRoutes = PROTECTED_ROUTES.flatMap((route) => {
    return [
      route.childRoutes
        ? route.childRoutes.map((childRoute, id) => {
            return (
              <Route
                key={id}
                path={`${route.url + childRoute.url}`}
                element={childRoute.component}
              />
            );
          })
        : [],
      <Route key={route.url} path={route.url} element={route.component} />,
    ];
  })
    .filter(Boolean)
    .flat();

  return (
    <div className={classes.Dashboard}>
      {/* <div className={classes.Title}>{title}</div> */}
      <div className="right-panel">
        <Header handleToggleSidebar={handleToggleSidebar} />
      </div>
      <div className={classes.Child}>
        <Routes>{processedRoutes}</Routes>
      </div>
      <Footer />
    </div>
  );
};

export default MainContainer;
